import type {
  InstanceSessionState,
  SocketState,
} from "./ManagerConnectionContext";

export function isActiveManagerConnected(
  activeSubdomain: string | null,
  socketStatesBySubdomain: Record<string, SocketState>,
): boolean {
  const trimmed = activeSubdomain?.trim();
  if (!trimmed) {
    return false;
  }
  return socketStatesBySubdomain[trimmed] === "connected";
}

export function markInstanceSessionLivestreamOffline(
  session: InstanceSessionState,
): InstanceSessionState {
  return {
    ...session,
    livestreamState: "offline",
    livestreamMessage: null,
    terminalReplayInProgress: false,
  };
}

export function shouldIgnoreOfflineReplayRestart(
  session: InstanceSessionState,
  endSequence: number,
): boolean {
  if (
    session.agentState !== "offline" ||
    session.livestreamState !== "offline" ||
    session.terminalReplayInProgress ||
    !session.terminalReplay
  ) {
    return false;
  }

  const currentReplayEndSequence =
    session.terminalReplay.endSequence ?? session.terminalReplayEndSequence;
  return endSequence === currentReplayEndSequence;
}
